import React, {useState} from "react";
import {updateProfile} from "../api/accounts";
import {ACCOUNT_TYPES, OPERATING_AREAS, PROPERTY_TYPES} from "../constants";
import {validateReraNumber} from "../validation";
import {Field, Section, numberOrNull} from "../components/Fields";
import MultiSelect from "../components/MultiSelect";

const ProfileTab = ({broker, onSaved}) => {
    const [form, setForm] = useState({
        fullName: broker.fullName || "", companyName: broker.companyName || "", reraNumber: broker.reraNumber || "",
        officeAddress: broker.officeAddress || "", numberOfProperties: broker.numberOfProperties ?? "",
        accountType: broker.accountType || "AGENT",
    });
    const [areas, setAreas] = useState(broker.operatingAreas || []);
    const [types, setTypes] = useState(broker.propertyTypes || []);
    const [state, setState] = useState({saving: false, error: "", saved: false});
    const set = (k) => (e) => { setForm((f) => ({...f, [k]: e.target.value})); setState((s) => ({...s, saved: false})); };

    const save = async (e) => {
        e.preventDefault();
        const reraError = validateReraNumber(form.reraNumber);
        if (form.fullName.trim().length < 3 || reraError) {
            setState({saving: false, saved: false, error: reraError || "Name must be at least 3 characters."});
            return;
        }
        setState({saving: true, error: "", saved: false});
        try {
            const updated = await updateProfile({
                ...form, numberOfProperties: numberOrNull(form.numberOfProperties), operatingAreas: areas, propertyTypes: types,
            });
            onSaved(updated);
            setState({saving: false, error: "", saved: true});
        } catch (err) {
            setState({saving: false, error: err.message, saved: false});
        }
    };

    return (
        <form className="brk-card" onSubmit={save}>
            <Section title="Your business" subtitle="Shown to our team; your company name is shown to buyers on your listings.">
                <Field label="Registered as">
                    <select className="brk-input" value={form.accountType} onChange={set("accountType")}>
                        {ACCOUNT_TYPES.map((t) => <option key={t.id} value={t.id}>{t.label}</option>)}
                    </select>
                </Field>
                <Field label="Full name" required><input className="brk-input" value={form.fullName} onChange={set("fullName")}/></Field>
                <Field label="Company" required><input className="brk-input" value={form.companyName} onChange={set("companyName")}/></Field>
                <Field label="RERA number"><input className="brk-input" value={form.reraNumber} onChange={set("reraNumber")}/></Field>
                <Field label="Office address" wide><input className="brk-input" value={form.officeAddress} onChange={set("officeAddress")}/></Field>
                <Field label="Mobile" hint="Verified. Contact us to change it.">
                    <input className="brk-input" value={`+91 ${broker.mobile}`} disabled/>
                </Field>
                <Field label="Email" hint="Verified. Contact us to change it."><input className="brk-input" value={broker.email} disabled/></Field>
                <Field label="Operating areas" wide group>
                    <MultiSelect options={OPERATING_AREAS.map((a) => ({id: a, label: a}))} selected={areas} onChange={setAreas}
                                 placeholder="Select operating areas"/>
                </Field>
                <Field label="Property types" wide group>
                    <MultiSelect options={PROPERTY_TYPES} selected={types} onChange={setTypes} placeholder="Select property types"/>
                </Field>
                <Field label="Properties you handle"><input className="brk-input" type="number" min="0" value={form.numberOfProperties}
                                                           onChange={set("numberOfProperties")}/></Field>
            </Section>
            <div className="brk-form-foot">
                {state.error && <p className="brk-form-error" role="alert">⚠ {state.error}</p>}
                {state.saved && <p className="brk-form-ok" role="status">Saved.</p>}
                <button type="submit" className="brk-btn brk-btn--primary" disabled={state.saving}>
                    {state.saving ? "Saving…" : "Save profile"}
                </button>
            </div>
        </form>
    );
};

export default ProfileTab;
